import { Navigate, useLocation } from "react-router-dom";
import useAuth from "./hooks/useAuth";

/**
 * Root "/" route — purely a redirect based on auth state.
 *
 * Pre-Phase-5 this also rendered a Loader when `loadingAuth` was
 * true, but `Page.tsx` already gates the entire Routes tree on
 * `initialFetchStatus`. By the time App mounts the boot has
 * resolved, so the local loading check was dead code — the
 * redirect was always the synchronous answer. Removed.
 */
export default function App() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location.pathname }} replace />;
  }

  return <Navigate to="/feed" replace />;
}
